import { cn } from "@/lib/utils";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import logoColorFallback from "@/assets/logo-color.png";
import logoWhiteFallback from "@/assets/logo-white.png";

interface BrandLogos {
  logo_color_url: string;
  logo_white_url: string;
}

interface LogoProps {
  className?: string;
  variant?: "color" | "white";
  size?: "sm" | "md" | "lg";
  fetchPriority?: "high" | "low" | "auto";
  loading?: "eager" | "lazy";
}

const Logo = ({ className, variant = "color", size = "md", fetchPriority, loading = "lazy" }: LogoProps) => {
  const { data: brandLogos } = useSiteSettings<BrandLogos>("brand_logos");

  const sizeClasses = {
    sm: "h-14",
    md: "h-24",
    lg: "h-32",
  };

  const dimensions = {
    sm: { width: 56, height: 56 },
    md: { width: 96, height: 96 },
    lg: { width: 128, height: 128 },
  };

  const dynamicSrc = variant === "white" ? brandLogos?.logo_white_url : brandLogos?.logo_color_url;
  const fallback = variant === "white" ? logoWhiteFallback : logoColorFallback;
  const src = dynamicSrc && dynamicSrc.trim() !== "" ? dynamicSrc : fallback;

  return (
    <img
      src={src}
      alt="La Petite Cannoise Beach Club"
      className={cn(sizeClasses[size], "w-auto object-contain", className)}
      width={dimensions[size].width}
      height={dimensions[size].height}
      fetchPriority={fetchPriority}
      loading={loading}
      decoding="async"
    />
  );
};

export default Logo;
